import { Answer } from "../../types";

export function getAnswerForWord(
  stepIndex: number,
  wordId: string,
  answer: Answer
) {
  const stepAnswers = answer.steps[stepIndex];

  return stepAnswers.hasOwnProperty(wordId) ? stepAnswers[wordId] : "";
}
